// eslint-disable-next-line consistent-return
function getWord(text, caretPos) {
  const words = text.split(' ');
  let x = 0;
  // eslint-disable-next-line no-plusplus
  for (let i = 0; i < words.length; i++) {
    x += words[i].length + 1;
    if (x >= caretPos) {
      return words[i];
    }
  }
}

export default function takeWordForSearchingPure(text, caretPos) {
  // eslint-disable-next-line no-shadow
  function checkSpace(text, caretPos) {
    const current = text.charAt(caretPos - 1);
    return /\s/.test(current);
  }
  if (!text || (text && checkSpace(text, caretPos))) return null;
  let word = getWord(text, caretPos);
  if (word) {
    word = word.replace(/['"“”]+/g, ''); // remove all quotes from query
  }
  return word;
}
